import { FC, SVGProps } from 'react'

import { ReactComponent as amazon } from 'Icons/shop/cards/amazon.svg'
import { ReactComponent as amex } from 'Icons/shop/cards/amex.svg'
import { ReactComponent as aura } from 'Icons/shop/cards/aura.svg'
import { ReactComponent as bb } from 'Icons/shop/cards/bb.svg'
import { ReactComponent as boleto } from 'Icons/shop/cards/boleto.svg'
import { ReactComponent as bradesco } from 'Icons/shop/cards/bradesco.svg'
import { ReactComponent as caixa } from 'Icons/shop/cards/caixa.svg'
import { ReactComponent as cielo } from 'Icons/shop/cards/cielo.svg'
import { ReactComponent as cirrus } from 'Icons/shop/cards/cirrus.svg'
import { ReactComponent as diners } from 'Icons/shop/cards/diners.svg'
import { ReactComponent as direct_debit } from 'Icons/shop/cards/direct_debit.svg'
import { ReactComponent as discover } from 'Icons/shop/cards/discover.svg'
import { ReactComponent as ebay } from 'Icons/shop/cards/ebay.svg'
import { ReactComponent as elavon } from 'Icons/shop/cards/elavon.svg'
import { ReactComponent as elo } from 'Icons/shop/cards/elo.svg'
import { ReactComponent as eway } from 'Icons/shop/cards/eway.svg'
import { ReactComponent as generic } from 'Icons/shop/cards/generic.svg'
import { ReactComponent as global } from 'Icons/shop/cards/global.svg'
import { ReactComponent as hsbc } from 'Icons/shop/cards/hsbc.svg'
import { ReactComponent as itau } from 'Icons/shop/cards/itau.svg'
import { ReactComponent as jcb } from 'Icons/shop/cards/jcb.svg'
import { ReactComponent as maestro } from 'Icons/shop/cards/maestro.svg'
import { ReactComponent as mastercard } from 'Icons/shop/cards/mastercard.svg'
import { ReactComponent as pagseguro } from 'Icons/shop/cards/pagseguro.svg'
import { ReactComponent as paypal } from 'Icons/shop/cards/paypal.svg'
import { ReactComponent as rede } from 'Icons/shop/cards/rede.svg'
import { ReactComponent as sage } from 'Icons/shop/cards/sage.svg'
import { ReactComponent as santander } from 'Icons/shop/cards/santander.svg'
import { ReactComponent as shopify } from 'Icons/shop/cards/shopify.svg'
import { ReactComponent as skrill } from 'Icons/shop/cards/skrill.svg'
import { ReactComponent as skrill_moneybookers } from 'Icons/shop/cards/skrill_moneybookers.svg'
import { ReactComponent as solo } from 'Icons/shop/cards/solo.svg'
import { ReactComponent as stone } from 'Icons/shop/cards/stone.svg'
import { ReactComponent as visa } from 'Icons/shop/cards/visa.svg'
import { ReactComponent as visa_electron } from 'Icons/shop/cards/visa_electron.svg'
import { ReactComponent as wallet } from 'Icons/shop/cards/wallet.svg'
import { ReactComponent as western } from 'Icons/shop/cards/western.svg'
import { ReactComponent as worldpay } from 'Icons/shop/cards/worldpay.svg'

export default {
  amazon,
  american_express: amex,
  amex,
  aura,
  bb,
  boleto,
  bradesco,
  caixa,
  cielo,
  cirrus,
  diners,
  direct_debit,
  discover,
  ebay,
  elavon,
  elo,
  eway,
  generic,
  global,
  hsbc,
  itau,
  jcb,
  maestro,
  mastercard,
  master: mastercard,
  pagseguro,
  paypal,
  rede,
  sage,
  santander,
  shopify,
  skrill_moneybookers,
  skrill,
  solo,
  stone,
  visa_electron,
  visa,
  wallet,
  western,
  worldpay,
} as { [key: string]: FC<SVGProps<SVGSVGElement>> }
